module.exports = __webpack_public_path__ + "img/X.d65747d8.jpg";